export default "__VITE_ASSET__CzDCu21b__"